/**
 * Format price with currency symbol
 * @param {number|string} value
 * @param {string} currency
 * @returns {string}
 */
export const formatPrice = (value, currency = "₹") => {
    const amount = Number(value);

    if (Number.isNaN(amount)) return `${currency}0`;

    return `${currency}${amount}`;
    // return `${currency}${amount.toLocaleString("en-IN")}`;

};
//<i class="bi bi-currency-rupee"></i>

export const formatDiscount = (value, discTag = "% OFF") => {
    const discount = Number(value);

    if (Number.isNaN(discount)) return `${discTag}0`;

    return `${discount}${discTag}`;
    // return `${currency}${amount.toLocaleString("en-IN")}`;

};